export const normalizeAddressResponse = (response, useNeighborhood = false) => {
    const isCitiesResponse = !!response.cities;
    let targetValue = '';
    if (useNeighborhood) {
        targetValue = 'neighborhoods';
    } else {
        targetValue = isCitiesResponse ? 'cities' : 'districts';
    }

    return (
        (response &&
            response[targetValue] &&
            response[targetValue].map(elem => ({ name: elem, label: elem }))) ||
        []
    );
};

export const getCitiesFailedResponseErorrMessage = () => 'Cities response was failed: ';
export const getDistrictsFailedResponseErorrMessage = city =>
    `Districts response by city ${city} was failed: `;
export const getNeighborhoodsFailedResponseErorrMessage = district =>
    `Neighborhoods response by district ${district} was failed: `;
